"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        fontSize: 16,
        lineHeight: `20px`,
        fontWeight: 600,
        color: theme.grey1,
        display: 'flex',
        alignItems: 'center'
    },
    suffix: {
        marginLeft: 7,
        flexShrink: 0
    }
});
//# sourceMappingURL=collection.title.style.js.map